import copy from './kpAdditionalUi.json';
import { normalizeLanguage } from './languages';

export const additionalCopy = (language: string, key: string): string => {
  const resources = copy as Record<string, Record<string, string>>;
  return resources[normalizeLanguage(language)]?.[key] || resources.en[key] || key;
};
